import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Form,
  FormGroup,
  FormField,
  Input,
  Checkbox,
  Icon
} from 'semantic-ui-react'

const CardRehabDeviceUX = (props: any) => {
    return(
      <div
        id="CardRehabHistoryUX-div-0"
        style={{display: "grid", gridTemplateColumns: "35% 1fr", height: "calc(100vh - 40px)"}}>
        <div
          id="CardRehabDeviceUX-div-1"
          style={{borderRight: "1px solid rgba(196, 196, 196, 1)", padding: "1rem"}}>
          
          <div
            id="CardRehabDeviceUX-div-3"
            style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem"}}>
            
            <div
              id="CardRehabDeviceUX-div-4"
              style={{fontWeight: "bold", fontSize: "1.15rem"}}>
              {props.languageUX === "en" ? "Physical Device List" : "รายการอุปกรณ์ทางกายภาพ"}
            </div>
            <div
              id="CardRehabDeviceUX-div-5">
              
              <Button
                color="green"
                icon={true}
                id="CardRehabDeviceUX-Button-6"
                onClick={props.onCreateDeviceFree}
                size="small"
                style={{display: props.showDeviceFree?"flex":"none"}}>
                <div
                  id="CardRehabDeviceUX-div-22"
                  style={{marginTop: "-1px"}}>
                  
                  <Icon
                    className="size small"
                    id="CardRehabDeviceUX-Icon-23"
                    name="plus">
                  </Icon>
                </div>
                <label
                  id="CardRehabDeviceUX-label-7">
                  {props.languageUX === "en" ? "Device-free" : "ไม่ต้องใช้อุปกรณ์"}
                </label>
              </Button>
            </div>
          </div>
          <Form
            id="CardRehabDeviceUX-Form-9">
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-10"
              inline={true}>
              <FormField
                id="CardRehabDeviceUX-FormField-12"
                inline={true}
                width={16}>
                <label
                  id="CardRehabDeviceUX-label-17"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Search :" : "ค้นหา :"}
                </label>
                <Input
                  fluid={true}
                  id="CardRehabDeviceUX-Input-18"
                  name="search"
                  onChange={props.onChangeFilter}
                  size="small"
                  value={props.filterDevice?.search??""}>
                </Input>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-13"
                style={{paddingRight: "0"}}>
                <div
                  id="CardRehabDeviceUX-div-19">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-11"
              inline={true}>
              <FormField
                id="CardRehabDeviceUX-FormField-14"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-15">
                <Checkbox
                  checked={props.filterDevice?.include_other_division??false}
                  id="CardRehabDeviceUX-Checkbox-20"
                  label={props.languageUX === "en" ? "Include other division" : "รวมแผนกอื่น ๆ"}
                  name="include_other_division"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-16">
                <Checkbox
                  checked={props.filterDevice?.include_inactive??false}
                  id="CardRehabDeviceUX-Checkbox-21"
                  label={props.languageUX === "en" ? "Include Inactive" : "รวมที่ไม่ได้ใช้งาน"}
                  name="include_inactive"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardRehabDeviceUX-div-61"
            style={{height: "calc(100vh - 13.25rem)", overflowY: "auto", overflowX: "hidden", margin: "0 -1rem"}}>
            {props.deviceList}
          </div>
        </div>
        <div
          id="CardRehabDeviceUX-div-2"
          style={{padding: "1.5rem 1rem 0"}}>
          
          <div
            id="CardRehabDeviceUX-div-24"
            style={{fontWeight: "bold", fontSize: "1.15rem", marginBottom: "1.45rem"}}>
            {props.deviceDetail?.id?"Detail": props.deviceDetail?.device_free?"Add device-fee slot":"Add new device"}
          </div>
          <div
            id="CardRehabDeviceUX-div-66"
            style={{display: props.deviceDetail?.has_appointments?"":"none", color: "rgba(217, 2, 2, 1)", margin: "-0.55rem 0px 0.45rem"}}>
            {props.languageUX === "en" ? "You cannot edit some details or delete this device because this device is already booked for patient appointments." : "คุณไม่สามารถแก้ไขรายละเอียดบางอย่างหรือลบอุปกรณ์นี้ได้ เนื่องจากอุปกรณ์นี้ถูกจองไว้สำหรับการนัดหมายของคนไข้แล้ว"}
          </div>
          <Form
            className="--override-disabled --grey"
            id="CardRehabDeviceUX-Form-25">
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-26"
              inline={true}
              style={{display: props.deviceDetail?.device_free?"none":""}}>
              <FormField
                id="CardRehabDeviceUX-FormField-27"
                inline={true}
                width={10}>
                <label
                  id="CardRehabDeviceUX-label-29"
                  style={{width: "100px", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Device name :" : "ชื่ออุปกรณ์ :"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardRehabDeviceUX-Input-31"
                  name="name"
                  onChange={props.onChangeValue}
                  value={props.deviceDetail?.name?? ""}>
                </Input>
              </FormField>
              <FormField
                className={props.formErrors?.qty?"error":""}
                id="CardRehabDeviceUX-FormField-28"
                inline={true}
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardRehabDeviceUX-label-30"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Qty of device :" : "จำนวนอุปกรณ์ :"}
                </label>
                <Input
                  disabled={props.deviceDetail?.has_appointments || props.readOnly}
                  id="CardRehabDeviceUX-Input-32"
                  name="qty_of_device"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[eE\-+.]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.deviceDetail?.qty_of_device?? ""}>
                </Input>
                <div
                  id="CardRehabDeviceUX-div-67"
                  style={{position: "absolute", bottom: "-1.35rem", right: "1rem", color: "#9f3a38", display: props.formErrors?.qty? "":"none", fontSize: "0.75rem"}}>
                  {props.languageUX === "en" ? "Please enter valid information" : "กรุณากรอกข้อมูลที่ถูกต้อง"}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-33"
              inline={true}>
              <FormField
                id="CardRehabDeviceUX-FormField-34"
                inline={true}>
                <label
                  id="CardRehabDeviceUX-label-37"
                  style={{width: "88px", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Service hour :" : "เวลาให้บริการ :"}
                </label>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-35"
                inline={true}
                width={4}>
                <label
                  id="CardRehabDeviceUX-label-38"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Start" : "เริ่ม"}
                </label>
                <div
                  id="CardRehabDeviceUX-div-41"
                  style={{width: "100%"}}>
                  {props.startTime}
                </div>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-36"
                inline={true}
                width={4}>
                <label
                  id="CardRehabDeviceUX-label-39"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "End" : "จบ"}
                </label>
                <div
                  id="CardRehabDeviceUX-div-42"
                  style={{width: "100%"}}>
                  {props.endTime}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-43"
              inline={true}>
              <FormField
                className={props.formErrors?.time?"error":""}
                id="CardRehabDeviceUX-FormField-44"
                inline={true}
                style={{position: "relative"}}
                width={6}>
                <label
                  id="CardRehabDeviceUX-label-46"
                  style={{width: "140px", fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Time per Slot (minutes)" : "เวลาต่อช่อง (นาที)"}
                </label>
                <Input
                  disabled={props.deviceDetail?.has_appointments || props.readOnly}
                  fluid={true}
                  id="CardRehabDeviceUX-Input-47"
                  name="time_per_slot"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[eE\-+.]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.deviceDetail?.time_per_slot ?? ""}>
                </Input>
                <div
                  id="CardRehabDeviceUX-div-68"
                  style={{position: "absolute", bottom: "-1.35rem", right: "1rem", color: "#9f3a38", display: props.formErrors?.time? "":"none", fontSize: "0.75rem"}}>
                  {props.languageUX === "en" ? "Please enter valid information" : "กรุณากรอกข้อมูลที่ถูกต้อง"}
                </div>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-45"
                inline={true}>
                <label
                  id="CardRehabDeviceUX-label-48"
                  style={{fontWeight: "normal", minWidth: "max-content", color: "rgba(137, 131, 131, 1)"}}>
                  {props.languageUX === "en" ? "Must be divisible by 1 hour (5, 10, 15, 20, 30, 60 minutes)" : "ต้องหารด้วย 1 ชั่วโมงลงตัว (5, 10, 15, 20, 30, 60 นาที)"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-49"
              inline={true}>
              <FormField
                id="CardRehabDeviceUX-FormField-51"
                inline={true}>
                <Checkbox
                  checked={props.deviceDetail?.allow_overbooking?? false}
                  disabled={props.readOnly}
                  id="CardRehabDeviceUX-Checkbox-53"
                  label={props.languageUX === "en" ? "Allow Overbooking" : "อนุญาตให้จองเกินจำนวน"}
                  name="allow_overbooking"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-50"
              inline={true}>
              <FormField
                id="CardRehabDeviceUX-FormField-52"
                inline={true}>
                <Checkbox
                  checked={props.deviceDetail?.active ?? false}
                  disabled={props.readOnly}
                  id="CardRehabDeviceUX-Checkbox-54"
                  label={props.languageUX === "en" ? "Active" : "คล่องแคล่ว"}
                  name="active"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-69"
                inline={true}
                style={{display:props.inactiveDate?"":"none"}}
                width={8}>
                <label
                  id="CardRehabDeviceUX-label-70"
                  style={{fontWeight: "normal", marginLeft: "-0.5rem",color: "rgb(217, 2, 2)"}}>
                  - This device will become inactive on
                </label>
                <label
                  id="CardRehabDeviceUX-label-71"
                  style={{fontWeight: "normal", marginLeft: "-0.5rem",color: "rgb(217, 2, 2)"}}>
                  {props.inactiveDate}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabDeviceUX-FormGroup-55"
              inline={true}
              style={{marginTop: "2rem"}}>
              <FormField
                id="CardRehabDeviceUX-FormField-56"
                inline={true}
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-57"
                inline={true}>
                <div
                  id="CardRehabDeviceUX-div-60">
                  {props.buttonSave}
                </div>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-62"
                style={{display: props.deviceDetail?.id && !props.deviceDetail?.has_appointments?"":"none"}}>
                <Button
                  color="red"
                  disabled={props.readOnly}
                  id="CardRehabDeviceUX-Button-64"
                  onClick={props.onDelete}
                  size="small">
                  {props.languageUX === "en" ? "DELETE" : "ลบ"}
                </Button>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-63"
                style={{display: props.deviceDetail?.id || props.deviceDetail?.device_free?"":"none"}}>
                <Button
                  color="red"
                  id="CardRehabDeviceUX-Button-65"
                  onClick={props.onClear}
                  size="small">
                  {props.languageUX === "en" ? "CLOSE" : "ปิด"}
                </Button>
              </FormField>
              <FormField
                id="CardRehabDeviceUX-FormField-58"
                inline={true}
                style={{display: props.deviceDetail?.id || props.deviceDetail?.device_free?"none":""}}>
                <Button
                  color="yellow"
                  id="CardRehabDeviceUX-Button-59"
                  onClick={props.onClear}
                  size="small">
                  {props.languageUX === "en" ? "CLEAR" : "ล้างหน้าจอ"}
                </Button>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardRehabDeviceUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:50:23 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"35% 1fr\", height: \"calc(100vh - 40px)\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{borderRight: \"1px solid rgba(196, 196, 196, 1)\", padding: \"1rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1.5rem 1rem 0\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", marginBottom: \"1rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการอุปกรณ์ทางกายภาพ",
          "valueEN": "Physical Device List"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.15rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 5,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCreateDeviceFree"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showDeviceFree?\"flex\":\"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ไม่ต้องใช้อุปกรณ์",
          "valueEN": "Device-free"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-7"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Form",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Form-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-13"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา :",
          "valueEN": "Search :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Input",
      "parent": 12,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Input-18"
        },
        "name": {
          "type": "value",
          "value": "search"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.filterDevice?.search??\"\""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Checkbox",
      "parent": 15,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDevice?.include_other_division??false"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Checkbox-20"
        },
        "label": {
          "type": "value",
          "value": "รวมแผนกอื่น ๆ",
          "valueEN": "Include other division"
        },
        "name": {
          "type": "value",
          "value": "include_other_division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Checkbox",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDevice?.include_inactive??false"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Checkbox-21"
        },
        "label": {
          "type": "value",
          "value": "รวมที่ไม่ได้ใช้งาน",
          "valueEN": "Include Inactive"
        },
        "name": {
          "type": "value",
          "value": "include_inactive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-1px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Icon",
      "parent": 22,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Icon-23"
        },
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deviceDetail?.id?\"Detail\": props.deviceDetail?.device_free?\"Add device-fee slot\":\"Add new device\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.15rem\", marginBottom: \"1.45rem\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Form",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Form-25"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.deviceDetail?.device_free?\"none\":\"\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 26,
      "props": {
        "className": {
          "type": "code",
          "value": "props.formErrors?.qty?\"error\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่ออุปกรณ์ :",
          "valueEN": "Device name :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-29"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100px\", fontWeight: \"normal\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนอุปกรณ์ :",
          "valueEN": "Qty of device :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Input",
      "parent": 27,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Input-31"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.deviceDetail?.name?? \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 28,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.deviceDetail?.has_appointments || props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Input-32"
        },
        "name": {
          "type": "value",
          "value": "qty_of_device"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[eE\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.deviceDetail?.qty_of_device?? \"\""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาให้บริการ :",
          "valueEN": "Service hour :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{width: \"88px\", fontWeight: \"normal\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "เริ่ม",
          "valueEN": "Start"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "จบ",
          "valueEN": "End"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startTime"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endTime"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 43,
      "props": {
        "className": {
          "type": "code",
          "value": "props.formErrors?.time?\"error\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาต่อช่อง (นาที)",
          "valueEN": "Time per Slot (minutes)"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{width: \"140px\", fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Input",
      "parent": 44,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.deviceDetail?.has_appointments || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Input-47"
        },
        "name": {
          "type": "value",
          "value": "time_per_slot"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[eE\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.deviceDetail?.time_per_slot ?? \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "ต้องหารด้วย 1 ชั่วโมงลงตัว (5, 10, 15, 20, 30, 60 นาที)",
          "valueEN": "Must be divisible by 1 hour (5, 10, 15, 20, 30, 60 minutes)"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-48"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\", color: \"rgba(137, 131, 131, 1)\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Checkbox",
      "parent": 51,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.deviceDetail?.allow_overbooking?? false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Checkbox-53"
        },
        "label": {
          "type": "value",
          "value": "อนุญาตให้จองเกินจำนวน",
          "valueEN": "Allow Overbooking"
        },
        "name": {
          "type": "value",
          "value": "allow_overbooking"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Checkbox",
      "parent": 52,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.deviceDetail?.active ?? false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Checkbox-54"
        },
        "label": {
          "type": "value",
          "value": "คล่องแคล่ว",
          "valueEN": "Active"
        },
        "name": {
          "type": "value",
          "value": "active"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormGroup",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormGroup-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2rem\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.deviceDetail?.id || props.deviceDetail?.device_free?\"none\":\"\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "CLEAR"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Button-59"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deviceList"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 13.25rem)\", overflowY: \"auto\", overflowX: \"hidden\", margin: \"0 -1rem\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-62"
        },
        "style": {
          "type": "code",
          "value": "{display: props.deviceDetail?.id && !props.deviceDetail?.has_appointments?\"\":\"none\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-63"
        },
        "style": {
          "type": "code",
          "value": "{display: props.deviceDetail?.id || props.deviceDetail?.device_free?\"\":\"none\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Button",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบ",
          "valueEN": "DELETE"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Button-64"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDelete"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Button",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิด",
          "valueEN": "CLOSE"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-Button-65"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "คุณไม่สามารถแก้ไขรายละเอียดบางอย่างหรือลบอุปกรณ์นี้ได้ เนื่องจากอุปกรณ์นี้ถูกจองไว้สำหรับการนัดหมายของคนไข้แล้ว",
          "valueEN": "You cannot edit some details or delete this device because this device is already booked for patient appointments."
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{display: props.deviceDetail?.has_appointments?\"\":\"none\", color: \"rgba(217, 2, 2, 1)\", margin: \"-0.55rem 0px 0.45rem\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณากรอกข้อมูลที่ถูกต้อง",
          "valueEN": "Please enter valid information"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-1.35rem\", right: \"1rem\", color: \"#9f3a38\", display: props.formErrors?.qty? \"\":\"none\", fontSize: \"0.75rem\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณากรอกข้อมูลที่ถูกต้อง",
          "valueEN": "Please enter valid information"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-1.35rem\", right: \"1rem\", color: \"#9f3a38\", display: props.formErrors?.time? \"\":\"none\", fontSize: \"0.75rem\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-FormField-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display:props.inactiveDate?\"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "- This device will become inactive on"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-70"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", marginLeft: \"-0.5rem\",color: \"rgb(217, 2, 2)\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inactiveDate"
        },
        "id": {
          "type": "value",
          "value": "CardRehabDeviceUX-label-71"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", marginLeft: \"-0.5rem\",color: \"rgb(217, 2, 2)\"}"
        }
      },
      "seq": 71,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardRehabDeviceUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
